import { Component, OnInit, Input, Output, EventEmitter, NgModule, AfterViewInit,ViewChild,ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SkeletonModule } from 'primeng/skeleton';

import { PDetailSidebarModule } from './../../../components/p-detail-sidebar/p-detail-sidebar.component';
import { DriverDetailModule } from './../../../components/driver-detail/driver-detail.component';
import { TruckDetailModule } from './../../../components/truck-detail/truck-detail.component';
import { ProgressBarModule } from 'primeng/progressbar';                                                            // 进度条
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { HttpHelpUtils } from './../../../utils/HttpHelpUtils';
import { TimelineModule } from 'primeng/timeline';
import { RadioButtonModule } from 'primeng/radiobutton';
import { BaseCommpont } from 'src/app/utils/BaseCommpont';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';
import { ConfirmationService } from 'primeng/api';
import { MessageSub } from './../../../utils/MessageSub';
import { DialogModule} from 'primeng/dialog';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { FieldsetModule } from 'primeng/fieldset';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { TooltipModule } from 'primeng/tooltip';
import { AccordionModule } from 'primeng/accordion';

import { RegExUtils } from './../../../utils/RegExUtils';
import { OssFileService } from './../../../components/oss-file/oss-file.service';
import { CommonConfirmModule } from './../../../components/common-confirm/common-confirm.component';
import { ImagePreviewService } from './../../image-viewer/image-preview.service';
import { ImageViewerModule } from './../../../components/image-viewer/image-viewer.directive';
import { CalendarModule } from '../../../components/calendar/calendar.component';
import { TagModule } from 'primeng/tag';

declare const TweenMax: any;
declare const Linear: any;
declare const TimelineMax: any;
declare const Cubic: any;

@Component({
    selector: 'app-truck-examine',
    templateUrl: './truck-examine.component.html',
    styleUrls: ['./truck-examine.component.scss'],
    providers: [ConfirmationService]
})
export class TruckExamineComponent implements OnInit, AfterViewInit {
    checkTruckForm: FormGroup;
    @Input() truckDetail: {} = {};                                             // 车辆输入详情
    @Output() onClose: EventEmitter<any> = new EventEmitter();                  // 关闭弹窗
     @Output() onChecked: EventEmitter<any> = new EventEmitter();                  // 审核完毕
    @Input() percentWidth = 80;                                                 // 宽度比例，默认是80%；
    @ViewChild("viewComponent") viewComponent: ElementRef;

    viewWidth = 0;
    localTruckDetail = {};                                                        // 运单详情
    bc = new BaseCommpont();
    regExUtils = new RegExUtils();                                                  // 校验规则
    checkTruckDialog = false;                                                     // 审核不通过窗口
    forceCheckTruckDialog = false;                                                // 强制审核通过
    scanItems = [];                                                                 // 扫描项
    truckId = '';
    loadingTruckInfo = false;

    vehicleTypeMap = {};
    vehicleTypeList = [];
    plateColorLists = []; //车牌颜色
    energyTypeLists = [];//车辆能源类型
    isPersonalLists = [];//车辆属性
    useCharacterLists = [];//使用性质
    truckModelLists = [];//车型
    truckSizeLists = [];//车辆尺寸
    plateColorMap = {}; //车牌颜色
    energyTypeMap = {};//车辆能源类型
    isPersonalMap = {};//车辆属性
    useCharacterMap = {};//使用性质
    truckModelMap = {};//车型
    truckSizeMap = {};//车长

    constructor(
        private httpHelp: HttpHelpUtils,
        private messageSub: MessageSub,
        private configSrv: ConfirmationService,
        private fb: FormBuilder,
        private imagePreviewService: ImagePreviewService,
        private ossFileService: OssFileService,
    ) { }

    riskColor = {
        1: 'red',
        5: '#c1c116',
        10: 'green'
    }

    riskType = {
        1: '高风险',
        5: '中风险',
        10: '低风险'
    }

    useStatus = {                                                     // 使用状态
        0: '空闲',
        1: '工作中'
    };

    isOnlineMap = {
        1:'查不到入网',
        2:'未入网',
        3:'已入网'
    }

    checkFlag = {
        0: "待提交",
        1: "待审核",
        2: "已审核",
        3: "审核不过"
    }

    // =========================审核以及扫描方法
    scanData = null;
    robotClick = null;
    rightHandShake = null;
    scanStop = false;
    leftHandShake = null;
    reScanHeight = 0;
    scanRunning = false;
    eyeShake: any;
    robotBackTrans: any;

    closeDetail() {
        this.onClose.emit();
    }

    getCheckFlag = (val) => {
        if (val == 0) {
            return '#EE9A00';
        } else if (val == 1) {
            return '#B15BFF';
        } else if (val == 2) {
            return '#00A600';
        }else if (val == 3) {
            return '#EA0000';
        }
    }

    // 扫描动作
    scanAnimation() {
        const that = this;
        TweenMax.to(".scanItems", 1, {
            height: 0,
            autoAlpha: 0,
            visibility: "hidden",
            ease: Cubic.easeInOut,
            overwrite: "none"
        });
        that.scanRunning = true;
        if (that.robotBackTrans) {
            that.robotBackTrans.play();
        } else {
            that.robotBackTrans = new TweenMax.to(".robot-back", 1, {repeat: -1, rotation: 360, ease: Linear.easeNone});
        }
        TweenMax.to(".robot-back", 1, {height: '170px', width: '170px', ease: Linear.easeNone});
        TweenMax.to(".scan-stop", 0.1, {visibility: "hidden"});
        TweenMax.to(".scan-run", 0.1, {visibility: "inherit"});
    }
    
    // 停止扫描动作
    scanStopAnimation() {
        const that = this;
        that.scanRunning = false;
        if (that.eyeShake) {
            that.eyeShake.play();
        } else {
            that.eyeShake = new TweenMax.to(".leftEye,.rightEye", 1, {repeat: -1, transform: 'rotateX(-75deg)', ease: Linear.easeNone, yoyo:true}); 
        }
        TweenMax.to(".scan-stop", 0.1, {visibility: "inherit"});
        TweenMax.to(".scan-run", 0.1, {visibility: "hidden"});
        // 显示下拉
        if (that.reScanHeight == 0) {
            that.reScanHeight  = document.getElementById('scanItems').offsetHeight + 20 < 74 ? 74 : document.getElementById('scanItems').offsetHeight + 20;
        }
        TweenMax.to(".robot-back", 1, {height: '110px', width: '110px', ease: Linear.easeNone});
        that.robotBackTrans.pause();

        TweenMax.set(".scanItems", {
            height: 0,
            autoAlpha: 0,
            visibility: "hidden"
        });

        TweenMax.set(".scanChild", {
            autoAlpha: 0,
            visibility: "hidden"
        });

        const tlm = new TimelineMax();


        // animate stuff
        tlm.to(".scanItems", 1, {
            height: that.reScanHeight,
            autoAlpha: 1,
            visibility: "inherit",
            ease: Cubic.easeInOut,
            overwrite: "none"
        }).to(".scanChild", 0.5, {
            autoAlpha: 1,
            visibility: "inherit"
        });
    }
    
    // 监听点击事件
    initRodotClick() {
        const that  = this;
        document.getElementById("robot").addEventListener("click", () => {
            if (that.scanRunning) {
                return;
            }
        });

        // 监听双击事件
        document.getElementById("robot").addEventListener("dblclick", () => {
            if (that.scanRunning) {
                return;
            }
            that.scanRunning = true;
            that.queryTotalRiskItem();
        });
    }
    
    // 重新设置robot
    resetRobot() {
        // this.scanData.
        TweenMax.to( "#faces", 0.5, { x: 0 });

        TweenMax.set("#left-hand", {
            x: 20,
            y: -20,
            transformOrigin: "right center"
        });
        TweenMax.to( "#left-hand", 0.5, { x: 0 });
        if (this.leftHandShake) {
            this.leftHandShake.play();
        } else {
            this.leftHandShake = TweenMax.to( "#left-hand", 0.5, { rotation: 20, yoyo: true, ease: "sine.inOut" });
        }
        TweenMax.to( "#right-hand", 0.4, { rotation: 0 } );
        const that = this;
        if (that.reScanHeight == 0) {
            that.reScanHeight  = document.getElementById('scanItems').offsetHeight + 20;
        }
        
        TweenMax.set(".scanItems", {
            height: 0,
            autoAlpha: 0,
            visibility: "hidden"
        });
        // animate stuff
        TweenMax.to(".scanItems", 1, {
            delay: 0.5,
            height: that.reScanHeight,
            autoAlpha: 1,
            visibility: "inherit",
            ease: Cubic.easeInOut,
            overwrite: "none"
        });
    }
    
    queryTotalRiskItem() {
        this.scanAnimation();
        this.httpHelp.get('psg/risk/get-total-risk-data', {riskType: 2}).then(res => {
            if (res['status'] == 'success') {
                const riskList: [] = res['data']['riskList'];
                this.analysisTotalRiskData(riskList);
            }
        });
    }
    
    // 风控项涉及接口以及数据，分接口异步处理
    analysisTotalRiskData(data:[]) {
        const that = this;
        let func:any = [];
        data.forEach(e => {
            func.push(that.analysisSingleData(e));
        });

        let tempScanItem = [];
        Promise.all(func).then(res => {
            res.forEach(e => {
                if (e['status'] == 'success') {
                    const items:{} = e['data'];
                    for (let key in items) {
                        if (items[key].indexOf('1-') != -1) {
                            tempScanItem.push({
                                key: key,
                                label: items[key].split('-')[2],
                                status: 1,
                                riskType: items[key].split('-')[1]
                            });
                        } else {
                            tempScanItem.push({
                                key: key,
                                label: key + '校验通过',
                                status: 0
                            });
                        }
                    }
                }
            });
            tempScanItem.sort((a, b) => b['status'] - a['status'] || a['riskType'] - b['riskType']);
            that.scanStopAnimation();
            that.scanItems = tempScanItem;
        });
    }
    
    analysisSingleData(item) {
        return this.httpHelp.get('psg/risk/analysis-single-risk-data', 
        {dataId: this.truckId, riskDataId: item['riskDataId']});
    }

    checkTruck(status) {
        const that = this;
        if (status == 15) {
            that.saveCheckTruck(status);
        } else if (status == 10) {
            let heightRisk = false;
            let middleRisk = false;
            that.scanItems.forEach(e => {
                if (e['riskType'] == 1) {
                    heightRisk = true;
                }
                if (e['riskType'] == 5) {
                    middleRisk = true;
                }
            });
            if (heightRisk) {
                // 有高风险，不能审核通过，提示有高风险，请先处理高风险
                that.bc.showMessage(that.messageSub,  '扫描中有高风险项，请先处理高风险项，再进行审核通过', 'error');
                return;
            }
            if (middleRisk) {
                that.forceCheckTruckDialog = true;
                return;
            }
            that.saveCheckTruck(10);
        }
    }
    
    // 审核运单操作
    saveCheckTruck(status, msg?) {
        const that = this;
        if (status == 15) { // 原审核不通过操作
            if (that.checkTruckForm.controls['checkLog'].invalid) {
                that.checkTruckForm.controls['checkLog'].markAsDirty();
                that.checkTruckForm.controls['checkLog'].updateValueAndValidity();
                return;
            }
            const options = {
                id: that.truckId,
                checkLog: that.checkTruckForm.get('checkLog').value
            };
            that.httpHelp.post('psg/trucks/noCheck-trucks',
                options
              ).then(res => {
                that.httpHelp.loadingBlock = false;
                if (res['status'] == 'success') {
                    if (status == 15) {
                        that.checkTruckDialog = false;
                    }
                    that.forceCheckTruckDialog = false;
                    this.onClose.emit();
                     this.onChecked.emit()
                } else {
                   that.bc.showMessage(that.messageSub, res['message'], 'error');
                }
              });
            return;
        }
        this.configSrv.confirm({
            message: msg || '确定'+ (status == 10 ? '审核通过' : '审核不通过') +'吗？',
            icon: 'pi pi-exclamation-triangle',
            header: '审核确认',
            acceptLabel: '确定',
            rejectLabel: '取消',
            rejectButtonStyleClass: 'p-button-raised p-button-text p-button-plain',
            accept: () => {
                this.httpHelp.loadingBlock = false;
                this.httpHelp.get('psg/trucks/check-trucks', // 原先审核通过操作
                        {
                            ids: this.truckId,
                            checkFlag: 2,
                            checkLog: that.checkTruckForm.get('checkLog').value
                            // ,riskItems: JSON.stringify(that.scanItems) 
                        }).then(res => {
                    if (res['status'] == 'success') {
                        if (status == 15) {
                            that.checkTruckDialog = false;
                        }
                        that.forceCheckTruckDialog = false;
                        this.onClose.emit();
                         this.onChecked.emit()
                        that.bc.showMessage(that.messageSub, (status == 10 ? '审核通过' : '审核不通过') + '成功');
                    }
                });
            },
            reject: () => {

            },
            key: 'confirm'
        });
    }

    // ========================审核以及扫描方法结束============================== //

    imgPriview;                                                               // 展示图
    thumbnailImageSrc = [];                                                       // 缩略图
    current = 0;                                                                  // 旋转角度
    imgDescribe = '';
    vehicleLicensePhoto = '';
    vehicleLicenseBackPhoto = '';
    optCertPhoto = '';
    vehicleLicenseCheckPhoto = ''; // 行驶证年审页
    relDriverList = [];
    relTeamList = [];
    relAgentList = [];
    relCusList = [];
    checkList = [];
     //打开审核弹框
    checkDriverFlag() {
        this.thumbnailImageSrc = [];
        this.imgDescribe = '';
        this.vehicleLicensePhoto = '';
        this.optCertPhoto = '';
        this.relDriverList = [];
        this.relTeamList = [];
        this.relAgentList = [];
        this.relCusList = [];
        this.checkList = [];
        this.loadingTruckInfo = true;
        this.httpHelp.get('psg/trucks/get-plateNumber-list', { truckId: this.truckId }).then(res => {
            this.loadingTruckInfo = false;
            if (res['status'] == 'success') {
                if (res['data']) {
                    //参数数据
                    this.localTruckDetail = res['data'];
                    this.localTruckDetail['expiredWarnDay'] = res['data']['expiredWarnDay'];
                    // this.truckId = this.localTruckDetail['id'];
                    // 行驶证
                    if (this.localTruckDetail['vehicleLicensePhoto']) {
                        this.ossFileService.viewOSSFile(this.regExUtils.TRUCK, this.localTruckDetail['vehicleLicensePhoto']).then(res1 => {
                        if (res['status'] == 'success') {
                            this.vehicleLicensePhoto = res1['data']['url'];
                            let obj = { 'url': this.vehicleLicensePhoto, 'title': '行驶证' };
                            this.thumbnailImageSrc.push(obj);
                            if (this.thumbnailImageSrc.length > 0) {
                            this.imgDescribe = this.thumbnailImageSrc[0]['title'];
                            }
                        }
                        })
                    }
                    // 行驶证副页
                    if (this.localTruckDetail['vehicleLicenseBackPhoto']) {
                        this.ossFileService.viewOSSFile(this.regExUtils.TRUCK, this.localTruckDetail['vehicleLicenseBackPhoto']).then(res1 => {
                            if (res['status'] == this.bc.svrType) {
                                this.vehicleLicenseBackPhoto = res1['data']['url'];
                                let obj = { 'url': this.vehicleLicenseBackPhoto, 'title': '行驶证副页' };
                                this.thumbnailImageSrc.push(obj);
                                if (this.thumbnailImageSrc.length > 0) {
                                    this.imgDescribe = this.thumbnailImageSrc[0]['title'];
                                }
                            }
                        })
                    }
                    //道路运输证
                    if (this.localTruckDetail['optCertPhoto']) {
                        this.ossFileService.viewOSSFile(this.regExUtils.TRUCK, this.localTruckDetail['optCertPhoto']).then(res2 => {
                        if (res['status'] == 'success') {
                            this.optCertPhoto = res2['data']['url']
                            let obj = { 'url': this.optCertPhoto, 'title': '道路运输证' };
                            this.thumbnailImageSrc.push(obj);
                            if (this.thumbnailImageSrc.length > 0) {
                            this.imgDescribe = this.thumbnailImageSrc[0]['title'];
                            }
                        }
                        })
                    }
                    // 行驶证年审页
                    if (this.localTruckDetail['vehicleLicenseCheckPhoto']) {
                        this.ossFileService.viewOSSFile(this.regExUtils.TRUCK, this.localTruckDetail['vehicleLicenseCheckPhoto']).then(res2 => {
                        if (res['status'] == 'success') {
                            this.vehicleLicenseCheckPhoto = res2['data']['url']
                            let obj = { 'url': this.vehicleLicenseCheckPhoto, 'title': '行驶证年审页' };
                            this.thumbnailImageSrc.push(obj);
                            if (this.thumbnailImageSrc.length > 0) {
                            this.imgDescribe = this.thumbnailImageSrc[0]['title'];
                            }
                        }
                        })
                    }
                }
                //加载审核日志
                this.httpHelp.get('psg/operateLog/get-check-log-list', { objId: this.truckId, objType: 10 }).then(res2 => {
                if (res2['status'] == 'success') {
                    this.checkList = [{
                    remark: '',
                    status: 1,
                    createTime: this.localTruckDetail['createTime'],
                    creatorName: this.localTruckDetail['creatorName']
                    }];
                    let data = res2['data'];
                    if (data) {
                    data.forEach(item => {
                        this.checkList.push({
                        status: item.status,
                        createTime: item.createTime,
                        creatorName: item.creatorName,
                        remark: item.remark
                        });
                    });
                    }
                } else {
                    this.bc.showMessage(this.messageSub, '加载审核日志异常：' + res2['message'], 'error');
                }
                });
            } else {
                this.bc.showMessage(this.messageSub, '加载基础数据异常：' + res['message'], 'error');
            }
        });
        //加载关联数据
        this.httpHelp.get('psg/trucks/get-truck-rel-detail', { truckId: this.truckId }).then(res => {
            if (res['status'] == 'success') {
                if (res['data']) {
                this.relDriverList = res['data']['relDriverList'];
                this.relTeamList = res['data']['relTeamList'];
                //加载代理商
                if (res['data']['relAgentList'].length > 0) {
                    let agentIds = '';
                    let relAgentListTmp = res['data']['relAgentList'];
                    relAgentListTmp.forEach(item => {
                    agentIds += item.agentId + ',';
                    });
                    this.httpHelp.get('sys/agent/query-rel-agent', { ids: agentIds }).then(res => {
                    if (res['status'] == 'success') {
                        this.relAgentList = res['data'];//关联代理商信息
                    } else {
                    }
                    });
                }
                //关联货主信息
                if (res['data']['relCusList'].length > 0) {
                    let custIds = '';
                    let relCusListTmp = res['data']['relCusList'];
                    relCusListTmp.forEach(item => {
                    custIds += item.shipperId + ',';
                    });
                    //加载货主
                    this.httpHelp.get('sys/cust/query-rel-cust', { ids: custIds }).then(res => {
                    if (res['status'] == 'success') {
                        this.relCusList = res['data'];
                    } else {
                    }
                    });
                }
                }
            } else {
                this.bc.showMessage(this.messageSub, '加载基础数据异常：' + res['message'], 'error');
            }
        });

    }
    // 预览右侧缩略图
    previewThumbnailImage() {
        var img = document.querySelector('.img-preview-img').getAttribute("src")
        let show_photo_list = [];
        let index = 0;
        for (var i = 0; i < this.thumbnailImageSrc.length; i++) {
        let e = this.thumbnailImageSrc[i];
        if (e['url'] == img) {
            index = i;
        }
        show_photo_list.push(e['url']);
        }
        this.imagePreviewService.preview(show_photo_list, index);
    }
    // 向左旋转
    handleTurnLeft() {
        let img = <HTMLImageElement>document.querySelector('.img-preview')
        this.current = (this.current - 90) % 360;
        img.style.transform = 'rotate(' + this.current + 'deg)'
    }
    // 向右旋转
    handleTurnright() {
        let img = <HTMLImageElement>document.querySelector('.img-preview')
        this.current = (this.current + 90) % 360;
        img.style.transform = 'rotate(' + this.current + 'deg)'
    }
    // 预览图切换
    previewImgIndex = 0                                                                           // 小图下标
    afiles = [];
    handlePreviewImgClick(item, i) {
        this.imgPriview = item.url;
        this.imgDescribe = item.title;
        this.previewImgIndex = i;
        this.current = 0
        this.afiles.push(this.imgPriview)
    }
    // ============================车主审核初始化============================ //

    getTruckDic() {
        //加载代码表
        this.httpHelp.get('psg/diction/dicType', { 
                dicTypes: 'vehicle_classification_code,plate_color,energy_type,is_personal,use_character,truck_length,truck_type' 
        }).then(res => {
            if (res['status'] == 'success') {
                this.vehicleTypeMap = {};
                this.plateColorMap = {};
                const tempGoodsTypeList = res['data'];
                tempGoodsTypeList.forEach(e => {
                    //车辆类型
                    if (e['dicType'] == 'vehicle_classification_code') {
                        this.vehicleTypeMap[e['value']] = e['text'];
                        this.vehicleTypeList.push({
                        label: e['text'],
                        value: e['value']
                        })
                    }
                    //车牌颜色
                    if (e['dicType'] == 'plate_color') {
                        this.plateColorMap[e['value']] = e['text'];
                        this.plateColorLists.push({
                        label: e['text'],
                        value: e['value']
                        })
                    }
                    //车辆能源类型
                    if (e['dicType'] == 'energy_type') {
                        this.energyTypeMap[e['value']] = e['text'];
                        this.energyTypeLists.push({
                        label: e['text'],
                        value: e['value']
                        })
                    }
                    //车辆属性
                    if (e['dicType'] == 'is_personal') {
                        this.isPersonalMap[e['value']] = e['text'];
                        this.isPersonalLists.push({
                        label: e['text'],
                        value: e['value']
                        })
                    }
                    //使用性质
                    if (e['dicType'] == 'use_character') {
                        this.useCharacterMap[e['value']] = e['text'];
                        this.useCharacterLists.push({
                        label: e['text'],
                        value: e['value']
                        })
                    }
                    //车长
                    if (e['dicType'] == 'truck_length') {
                        this.truckSizeMap[e['value']+''] = e['text'];
                        this.truckSizeLists.push({
                        label: e['text'],
                        value: e['value']+''
                        })
                    }
                    //车型
                    if (e['dicType'] == 'truck_type') {
                        this.truckModelMap[e['value']] = e['text'];
                        this.truckModelLists.push({
                        label: e['text'],
                        value: e['value']
                        })
                    }
                })
            } else {
            }
        });
    }


    // 查看司机人车照
    checkDriverTruckPhoto(data) {
        if (!data || !data['driverTruckPhoto']) {
            this.bc.showMessage(this.messageSub, '未找到人车照片信息', 'error');
            return;
        }
        
        this.ossFileService.viewOSSFile(this.regExUtils.TRUCK, data['driverTruckPhoto'], 2).then(res => {
            if (res['status'] == this.bc.svrType) {
                if (res['data'] && res['data']['url']) {
                    this.imagePreviewService.preview([
                        res['data']['url']
                    ]);
                } else {
                    this.bc.showMessage(this.messageSub, '获取照片失败：未找到图片地址', 'error');
                }
            } else {
                this.bc.showMessage(this.messageSub, '获取照片失败：' + res['message'], 'error');
            }
        }).catch(err => {
            console.error('查看人车照失败:', err);
            this.bc.showMessage(this.messageSub, '查看人车照失败', 'error');
        });
    }

    //查看车主协议
    checkTeamAgreePhoto(data){
        if (!data || !data['agreementPhoto']) {
            this.bc.showMessage(this.messageSub, '未找到挂靠协议信息', 'error');
            return;
        }
        
        // 车主挂靠协议需要传递 vehicleType=2
        this.ossFileService.viewOSSFile(this.regExUtils.TEAM, data['agreementPhoto'], 2).then(res => {
            if (res['status'] == this.bc.svrType) {
                if (res['data'] && res['data']['url']) {
                    this.imagePreviewService.preview([
                        res['data']['url']
                    ]);
                } else {
                    this.bc.showMessage(this.messageSub, '获取协议失败：未找到图片地址', 'error');
                }
            } else {
                this.bc.showMessage(this.messageSub, '获取协议失败：' + res['message'], 'error');
            }
        }).catch(err => {
            console.error('查看挂靠协议失败:', err);
            this.bc.showMessage(this.messageSub, '查看挂靠协议失败', 'error');
        });
    }

    // 查看车辆挂靠协议
    checkAffiliationAgreement() {
        if (!this.localTruckDetail['agreementPhoto']) {
            this.bc.showMessage(this.messageSub, '未找到挂靠协议信息', 'error');
            return;
        }
        
        const photoFiles = this.localTruckDetail['agreementPhoto'].split(',');
        const promises = photoFiles.map(fileName => {
            return this.ossFileService.viewOSSFile(this.regExUtils.AFFILIATION_AGREEMENT, fileName, 2).then(res => {
                if (res && res['data'] && res['data']['url']) {
                    return res['data']['url'];
                }
                return null;
            }).catch(err => {
                console.error('加载挂靠协议图片失败:', err);
                return null;
            });
        });

        Promise.all(promises).then(urls => {
            const validUrls: string[] = urls.filter(url => url !== null) as string[];
            if (validUrls.length > 0) {
                this.imagePreviewService.preview(validUrls);
            } else {
                this.bc.showMessage(this.messageSub, '获取挂靠协议图片失败', 'error');
            }
        });
    }

    loadingRelInfo = false;

    ngOnInit(): void {
        this.checkTruckForm = this.fb.group({
            checkLog: [null, [Validators.required]],
        });
    }

    ngAfterViewInit(): void {
        this.viewWidth = this.viewComponent.nativeElement.offsetWidth;

        // AI机器人测评功能已隐藏
        // this.initRodotClick();
        // this.queryTotalRiskItem();

        this.localTruckDetail = this.truckDetail;
        this.truckId = this.localTruckDetail['id'] || this.truckDetail['truckId'];
        
        const that = this;
        that.getTruckDic();
        that.checkDriverFlag();
    }

}

@NgModule({
    imports: [CommonModule, FormsModule, ReactiveFormsModule, SkeletonModule, PDetailSidebarModule, 
        DriverDetailModule, TruckDetailModule, ProgressBarModule,
        DialogModule,
        TimelineModule,
        RadioButtonModule,
        CheckboxModule,
        ButtonModule,
        CommonConfirmModule,
        ImageViewerModule,
        InputTextareaModule,
        FieldsetModule,
        CalendarModule,
        ScrollPanelModule,
        TooltipModule,
        TagModule,
        AccordionModule
    ],
    exports: [TruckExamineComponent],
    declarations: [TruckExamineComponent]
})
export class TruckExamineModule { }
